var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"allPage"},[_c('Header',{staticClass:"header"}),_c('div',{staticClass:"Box scrollbar"},[_c('router-view',{staticClass:"content"})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }